<template>
  <div class="relative">
    <div
      v-if="headerCoverImage"
      class="page__header-cover absolute w-full h-full z-0 overflow-hidden"
      :class="{ 'opacity-25': enableCoverTransparency }"
    >
      <strapi-image
        class="page__header-cover__img w-full h-auto"
        :class="{
          'max-w-full mask-[linear-gradient(to_bottom,rgba(0,0,0,1)_70%,rgba(0,0,0,0)_100%)] [-webkit-mask-image:linear-gradient(to_bottom,rgba(0,0,0,1)_70%,rgba(0,0,0,0)_100%)]':
            enableCoverTransparency,
        }"
        :lazy="false"
        auto-scale
        :alt-fallback="
          name == null || name.length === 0
            ? 'Background'
            : `${name} Background`
        "
        :image="headerCoverImage"
      />
    </div>
    <div class="relative z-10">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiImage } from '~/apollo/types/types';

const props = withDefaults(
  defineProps<{
    headerCoverImage?: StrapiImage | null;
    name?: string;
    enableCoverTransparency?: boolean;
  }>(),
  {
    headerCoverImage: null,
    name: '',
    enableCoverTransparency: true,
  },
);
</script>
